
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Payhis from "../Accountandhistory/Food/Payhis";
import CashBillingdata from "../Accountandhistory/Food/CashBillingdata";
import MobileCashorders from "../Ordermanagment/Food/MobileCashorders";
import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";
import Logisticsaccountsdata from "./Logisticsaccountsdata";

// import "./NavBars"
// import Footer from "../common/components/Footer";

const Logisticsaccounts = () => {
    // const [activeCategory, setActiveCategory] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [ticketType, setTicketType] = useState("");

    const [attachment, setAttachment] = useState(""); // base64 image

    const [message, setMessage] = useState("");
    const [parentId, setParentId] = useState(null);
    // const [activeCategory, setActiveCategory] = useState("Allitems");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    // const [quantities, setQuantities] = useState({});
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const isMobile = window.innerWidth <= 768;


    const [dishes, setDishes] = useState([]);  // Added state for dishes
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    const [activeCategory, setActiveCategory] = useState("overview");


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                // Ensure we only get base64 data (after the comma)
                const base64Data = result.split(',')[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };



    const handleSendTicket = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "", // base64 encoded image
        };

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                console.error("API Error:", result);
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        }
    };





    useEffect(() => {
        if (location.state?.activeCategory === 'Payments') {
            setActiveCategory('Payments');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Profile') {
            setActiveCategory('Profile');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Notifications') {
            setActiveCategory('Notifications');
        }
    }, [location]);
    // Function to handle card click and set the active category
    const handleClick = (category) => {
        setActiveCategory(category);
    };

    const navigate = useNavigate();

    const iconMap = {
        overview: "",
        All: "",
        Pending: "",
        Closed: "",
        Cancelled: "",
    };



    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);


    const handleFilterClick = (type) => {
        if (type === "Veg") {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
        } else if (type === "Non-veg") {
            setIsNonVegSelected(true);
            setIsVegSelected(false);
        } else {
            setIsVegSelected(false);
            setIsNonVegSelected(false);
        }
    };



    // const categories = {


    // };

    const currentCategoryItems = categories[activeCategory] || [];

    const filteredItems = currentCategoryItems.filter((item) => {
        if (isVegSelected) return item.type === "Veg";
        if (isNonVegSelected) return item.type === "Non-veg";
        return true;
    });

    const addToCarts = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: 1 })); // Set initial quantity to 1
        setPopupItem(filteredItems.find((item) => item.id === id)); // Store clicked item
        setShowPopup(true);
    };

    const increaseQuantity = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    };

    const decreaseQuantity = (id) => {
        setQuantities((prev) => {
            const newQuantity = (prev[id] || 0) - 1;
            if (newQuantity <= 0) {
                const updatedQuantities = { ...prev };
                delete updatedQuantities[id]; // Remove item if quantity is 0
                return updatedQuantities;
            }
            return { ...prev, [id]: newQuantity };
        });
    };





    const addToCart = async (item, quantity = 1) => {
        console.log('addToCart called with dishId:', item.dishId);

        const apiUrl = `http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/cart/add/1`;

        const data = {
            dishId: item.dishId,
            quantity: quantity,
            price: (item.price * 0.9).toFixed(2)
        };

        try {
            const response = await axios.post(apiUrl, data, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.status === 200) {
                console.log('Item successfully added to cart:', response.data);
                alert('Item added to cart successfully!');
                navigate('/maamaascart');
            } else {
                console.error('Failed to add item to cart:', response.data);
                alert('Failed to add item to cart. Please try again.');
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);

            if (error.response) {
                console.error('Server Response:', error.response.data);

                if (error.response.status === 500) {
                    alert('Server Error: There’s an issue with the backend. Please try again later.');
                } else if (error.response.status === 404) {
                    alert('Item not found. Please try again.');
                } else {
                    alert(`Error: ${error.response.data}`);
                }
            } else {
                alert('An unexpected error occurred. Please try again.');
            }
        }
    };


    useEffect(() => {
        axios.get('http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/dish/getall')
            .then((response) => {
                const allDishes = response.data;

                // Filter for dishes with the name "Combos"
                const combos = allDishes.filter(dish => dish.dishName === "Combos");

                // Find child dishes with matching parentId
                const filteredData = allDishes.filter(dish =>
                    combos.some(combo => combo.dishId === dish.parentId)
                );

                setPosts(filteredData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);











    return (
        <>
            <div className="container-fluid">

                <div className="row" style={{ marginTop: "60px" }}>

                    {/* Left Column - Scrollable Category List */}
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                        <div
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",

                            }}
                        >


                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "540px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {/* Category Cards */}
                                {[].map(
                                    (category, index) => (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            {/* Icon inside a fixed-size wrapper */}


                                            <div style={{ fontSize: "20px", fontWeight: "bold" }} className="category-card-body d-flex justify-content-center p-0">
                                                {category}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                            <MobileCashorders />

                        </div>
                    </div>

                    {/* Right Column - Content Based on Active Category */}
                    <div className="col-lg-7 col-md-7 col-sm-12 col-12 cartdta-mobiley" style={{ paddingLeft: "0px", paddingRight: "0px" }}  >

                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "80px",
                                left: isMobile ? "5px" : "275px",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/logisticsladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Logistics & Supply
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                // to="/company"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Account_History
                            </Link>


                        </p>


                        <div
                            style={{
                                marginTop: "55px",
                                // backgroundColor: "#f1f1f1",
                                borderRadius: "8px",
                            }}
                        >
                            {/* Show different details based on active category */}
                            {activeCategory === "overview" && (
                                <div>
                                    {/* <h3>Cart Details</h3> */}
                                    <Logisticsaccountsdata />
                                </div>
                            )}
                            {activeCategory === "Food" && (
                                <div>
                                    {/* <h3>Profile</h3>*/}
                                    <Payhis />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <CashBillingdata />
                    <div
                        style={{
                            position: "fixed",
                            bottom: "0px",
                            right: "32px",
                            width: "300px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            borderRadius: "10px",
                            overflow: "hidden",
                            transition: "height 0.3s ease-in-out",
                            height: isOpen ? "400px" : "50px",
                            zIndex: 9999,
                        }}
                    >
                        {/* Header with Toggle Button */}
                        <div
                            style={{
                                backgroundColor: "#b15cd6",
                                color: "#fff",
                                padding: "10px",
                                fontWeight: "bold",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                cursor: "pointer",
                            }}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <FaCommentAlt style={{ marginLeft: "10px" }} />
                            <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                            {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
                        </div>

                        {/* Chat Content */}
                        {isOpen && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                    overflowY: "auto",
                                    padding: "10px",
                                    height: "352px",
                                    scrollbarWidth: "none"
                                }}
                            >
                                <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

                                {/* Ticket Type Dropdown */}
                                <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                <select
                                    value={ticketType}
                                    onChange={(e) => setTicketType(e.target.value)}
                                    style={{
                                        marginBottom: "10px",
                                        padding: "8px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        outline: "none",
                                    }}
                                >
                                    <option value="">Select Ticket Type</option>
                                    <option value="PAYOUT_ISSUE">Payout Issue</option>
                                    <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                    <option value="ORDER_COMPLAINT">Order Complaint</option>
                                    <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                    <option value="OTHER">Other</option>
                                </select>

                                {/* Message Input */}
                                <label style={{ fontWeight: "bold" }}>Message</label>
                                <input
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Type your Issue here..."
                                    rows={3}
                                    style={{
                                        marginBottom: "10px",
                                        padding: "8px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        height: "50px"

                                    }}
                                />

                                {/* Attachment Upload */}
                                <label style={{ fontWeight: "bold" }}>Attachment</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ marginBottom: "10px" }}
                                />

                                {/* Submit Button */}
                                <button
                                    onClick={handleSendTicket}
                                    style={{
                                        padding: "10px",
                                        backgroundColor: "#b15cd6",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "5px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    Send Ticket
                                </button>
                            </div>
                        )}

                    </div>
                </div>




            </div>
        </>
    );
};

export default Logisticsaccounts;
